var _excluded = ["bodyClassName", "children", "background1", "background2", "title", "showClose", "visible", "onMaskClick", "closeOnMaskClick", "onClose", "hideBg", "background2Url", "closeIcoIsWhite"],
  _excluded2 = ["coverScreen", "bodyClassName"],
  _excluded3 = ["children", "onClose"],
  _excluded4 = ["bodyClassName", "children", "background1", "background2", "title", "showClose", "visible", "onMaskClick", "closeOnMaskClick", "onClose", "nothing", "hasTitle", "coverScreen", "hideBg", "background2Url"],
  _excluded5 = ["children"],
  _excluded6 = ["closeOnMaskClick"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Popup as PopupAntd, CenterPopup as CenterPopupAntd, Toast as ToastAntd } from 'antd-mobile';
import React, { cloneElement, useCallback, useEffect, useMemo, useState } from 'react';
import cx from 'classnames';
import styles from "./Popup.less";
import ReactDOM from 'react-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Toast() {}
Toast.show = function (p, isSuccess) {
  if (!isSuccess) {
    return ToastAntd.show(p);
  }
  var sP = p;
  return ToastAntd.show(_objectSpread(_objectSpread({}, sP), {}, {
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.toastContent,
      children: [isSuccess.tip ? /*#__PURE__*/_jsx("div", {
        className: styles.tip,
        children: isSuccess.tip
      }) : null, isSuccess.tiptext ? /*#__PURE__*/_jsx("div", {
        className: styles.tiptext,
        children: isSuccess.tiptext
      }) : null]
    }),
    icon: /*#__PURE__*/_jsx("div", {
      className: styles.toastTitle,
      children: /*#__PURE__*/_jsx("img", {
        alt: "",
        src: "https://img11.360buyimg.com/imagetools/jfs/t1/182041/13/27658/1457/63405006E381c146a/85da4255313520ad.png"
      })
    }),
    maskClassName: styles.toastMask
  }));
};
function PopupBg1() {
  return /*#__PURE__*/_jsx("div", {
    className: styles.bg1
  });
}
function PopupBg2(props) {
  var _props$url = props.url,
    url = _props$url === void 0 ? 'https://img14.360buyimg.com/imagetools/jfs/t1/194509/34/26621/9094/63481400Ed310e275/50e73b79d40a6b18.png' : _props$url;
  return /*#__PURE__*/_jsx("div", {
    className: styles.bg2,
    children: /*#__PURE__*/_jsx("img", {
      src: url,
      alt: ""
    })
  });
}
export function Popup(props) {
  var background2Url = props.background2Url;
  var bodyClassName = props.bodyClassName,
    children = props.children,
    _props$background = props.background1,
    background1 = _props$background === void 0 ? /*#__PURE__*/_jsx(PopupBg1, {}) : _props$background,
    _props$background2 = props.background2,
    background2 = _props$background2 === void 0 ? /*#__PURE__*/_jsx(PopupBg2, {
      url: background2Url
    }) : _props$background2,
    title = props.title,
    _props$showClose = props.showClose,
    showClose = _props$showClose === void 0 ? true : _props$showClose,
    visible = props.visible,
    onMaskClick = props.onMaskClick,
    _props$closeOnMaskCli = props.closeOnMaskClick,
    closeOnMaskClick = _props$closeOnMaskCli === void 0 ? true : _props$closeOnMaskCli,
    onClose = props.onClose,
    hideBg = props.hideBg,
    b2 = props.background2Url,
    closeIcoIsWhite = props.closeIcoIsWhite,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _bodyClassName = useMemo(function () {
    return cx(styles.popupBody, _defineProperty({}, styles.popupBodyTop, otherProps.position === 'top'), bodyClassName);
  }, [bodyClassName, otherProps.position]);
  var _useState = useState(visible),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  useEffect(function () {
    setShow(visible);
  }, [visible]);
  var close = useCallback(function () {
    setShow(false);
    onClose && onClose();
  }, [onClose]);
  return /*#__PURE__*/_jsx(PopupAntd, _objectSpread(_objectSpread({}, otherProps), {}, {
    bodyClassName: _bodyClassName,
    visible: show,
    closeOnMaskClick: closeOnMaskClick,
    onMaskClick: function onMaskClick() {
      if (closeOnMaskClick) {
        close();
      }
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.popup,
      children: [!hideBg ? /*#__PURE__*/_jsx("div", {
        className: styles.background1,
        children: background1
      }) : null, !hideBg ? /*#__PURE__*/_jsx("div", {
        className: styles.background2,
        children: background2
      }) : null, /*#__PURE__*/_jsxs("div", {
        className: styles.children,
        children: [title ? /*#__PURE__*/_jsx("div", {
          className: styles.title,
          children: title
        }) : null, showClose ? /*#__PURE__*/_jsx("div", {
          className: styles.closeIco,
          onClick: close,
          children: /*#__PURE__*/_jsx("img", {
            alt: "",
            src: !closeIcoIsWhite ? 'https://img12.360buyimg.com/imagetools/jfs/t1/112147/35/29305/1066/6318424dE541aa285/5abadd34157ccac6.png' : 'https://img14.360buyimg.com/imagetools/jfs/t1/176345/11/30926/1086/635d051cE32b142a7/33d1b2401f510107.png'
          })
        }) : null, /*#__PURE__*/_jsx("div", {
          className: styles.content,
          children: children
        })]
      })]
    })
  }));
}
export function CenterPopup(props) {
  var _props$coverScreen = props.coverScreen,
    coverScreen = _props$coverScreen === void 0 ? true : _props$coverScreen,
    bodyClassName = props.bodyClassName,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var _className = useMemo(function () {
    return cx(coverScreen ? styles.coverScreen : '', bodyClassName);
  }, [bodyClassName, coverScreen]);
  return /*#__PURE__*/_jsx(CenterPopupAntd, _objectSpread(_objectSpread({}, otherProps), {}, {
    className: _className
  }));
}
export function renderToBody(element, cb) {
  var container = document.createElement('div');
  document.body.appendChild(container);
  var timerFrame;
  function unmount() {
    cancelAnimationFrame(timerFrame);
    timerFrame = requestAnimationFrame(function () {
      var unmountResult = ReactDOM.unmountComponentAtNode(container);
      if (unmountResult && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    });
  }
  ReactDOM.render(element, container, cb);
  return unmount;
}
export var showModal = function showModal(props, cb) {
  var _resolve;
  var modalPromise = new Promise(function (resolve) {
    _resolve = resolve;
  });
  var children = props.children,
    onClose = props.onClose,
    restProps = _objectWithoutProperties(props, _excluded3);
  var _setVisible;
  var _hideFun;
  var unmount;
  var isUnmount = false;
  var Wrapper = function Wrapper() {
    var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];
    _setVisible = setVisible;
    var hide = function hide() {
      setVisible(false);
      onClose === null || onClose === void 0 || onClose();
    };
    _hideFun = hide;
    return /*#__PURE__*/_jsx(Popup, _objectSpread(_objectSpread({}, restProps), {}, {
      visible: visible,
      onClose: hide,
      afterClose: function afterClose() {
        isUnmount = true;
        unmount();
      },
      children: /*#__PURE__*/cloneElement(children, {
        modalVisible: setVisible,
        onOk: function onOk() {
          var _resolve2;
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          (_resolve2 = _resolve) === null || _resolve2 === void 0 || _resolve2(args);
        }
      })
    }));
  };
  var showFun = function showFun() {
    var _setVisible2;
    (_setVisible2 = _setVisible) === null || _setVisible2 === void 0 || _setVisible2(true);
    cb === null || cb === void 0 || cb();
  };
  var timerFrame;
  var toRender = function toRender() {
    cancelAnimationFrame(timerFrame);
    timerFrame = requestAnimationFrame(function () {
      isUnmount = false;
      unmount = renderToBody( /*#__PURE__*/_jsx(Wrapper, {}), showFun);
    });
  };
  modalPromise.show = function () {
    if (isUnmount) {
      toRender();
    } else {
      showFun === null || showFun === void 0 || showFun();
    }
  };
  var timer;
  modalPromise.hide = function () {
    var _hideFun2;
    var toUnmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var unmountTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
    (_hideFun2 = _hideFun) === null || _hideFun2 === void 0 || _hideFun2();
    if (toUnmount) {
      isUnmount = true;
      if (unmountTime) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var _unmount;
          (_unmount = unmount) === null || _unmount === void 0 || _unmount();
        }, unmountTime);
      } else {
        var _unmount2;
        (_unmount2 = unmount) === null || _unmount2 === void 0 || _unmount2();
      }
    }
  };
  toRender();
  return modalPromise;
};
export function PopupCenter(props) {
  var background2Url = props.background2Url;
  var bodyClassName = props.bodyClassName,
    children = props.children,
    _props$background3 = props.background1,
    background1 = _props$background3 === void 0 ? /*#__PURE__*/_jsx(PopupBg1, {}) : _props$background3,
    _props$background4 = props.background2,
    background2 = _props$background4 === void 0 ? /*#__PURE__*/_jsx(PopupBg2, {
      url: background2Url
    }) : _props$background4,
    title = props.title,
    _props$showClose2 = props.showClose,
    showClose = _props$showClose2 === void 0 ? true : _props$showClose2,
    visible = props.visible,
    onMaskClick = props.onMaskClick,
    _props$closeOnMaskCli2 = props.closeOnMaskClick,
    closeOnMaskClick = _props$closeOnMaskCli2 === void 0 ? true : _props$closeOnMaskCli2,
    onClose = props.onClose,
    nothing = props.nothing,
    hasTitle = props.hasTitle,
    coverScreen = props.coverScreen,
    hideBg = props.hideBg,
    b2 = props.background2Url,
    otherProps = _objectWithoutProperties(props, _excluded4);
  var _bodyClassName = useMemo(function () {
    return cx(styles.popupCenterBody, bodyClassName);
  }, [bodyClassName]);
  var _useState5 = useState(visible),
    _useState6 = _slicedToArray(_useState5, 2),
    show = _useState6[0],
    setShow = _useState6[1];
  useEffect(function () {
    setShow(visible);
  }, [visible]);
  var close = useCallback(function () {
    setShow(false);
    onClose && onClose();
  }, [onClose]);
  var realMaskClick = useCallback(function (event) {
    if (closeOnMaskClick) {
      close();
    }
    onMaskClick === null || onMaskClick === void 0 || onMaskClick(event);
  }, []);
  return /*#__PURE__*/_jsx(CenterPopupAntd, _objectSpread(_objectSpread({}, otherProps), {}, {
    bodyClassName: _bodyClassName,
    visible: show,
    closeOnMaskClick: closeOnMaskClick,
    onMaskClick: realMaskClick,
    className: cx(coverScreen ? styles.coverScreenPoup : ''),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.popupCenter,
      children: [!nothing && !hideBg ? /*#__PURE__*/_jsx("div", {
        className: styles.background1,
        children: background1
      }) : null, !nothing && !hideBg ? /*#__PURE__*/_jsx("div", {
        className: styles.background2,
        children: background2
      }) : null, /*#__PURE__*/_jsxs("div", {
        className: styles.children,
        children: [hasTitle === false ? null : /*#__PURE__*/_jsx("div", {
          className: styles.title,
          children: title
        }), showClose ? /*#__PURE__*/_jsx("div", {
          className: styles.closeIco,
          onClick: close,
          children: /*#__PURE__*/_jsx("img", {
            alt: "",
            src: "https://img12.360buyimg.com/imagetools/jfs/t1/112147/35/29305/1066/6318424dE541aa285/5abadd34157ccac6.png"
          })
        }) : null, /*#__PURE__*/_jsx("div", {
          className: styles.content,
          onClick: realMaskClick,
          children: children
        })]
      })]
    })
  }));
}
export var showModalCenter = function showModalCenter(props, cb) {
  var _resolve;
  var modalPromise = new Promise(function (resolve) {
    _resolve = resolve;
  });
  var children = props.children,
    restProps = _objectWithoutProperties(props, _excluded5);
  var _setVisible;
  var _hideFun;
  var unmount;
  var isUnmount = false;
  var Wrapper = function Wrapper() {
    var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      visible = _useState8[0],
      setVisible = _useState8[1];
    _setVisible = setVisible;
    var hide = function hide() {
      setVisible(false);
      //   restProps?.onClose?.();
    };
    _hideFun = hide;
    return /*#__PURE__*/_jsx(PopupCenter, _objectSpread(_objectSpread({}, restProps), {}, {
      visible: visible,
      onClose: hide,
      afterClose: function afterClose() {
        isUnmount = true;
        unmount();
      },
      children: /*#__PURE__*/cloneElement(children, {
        modalVisible: setVisible,
        onOk: function onOk() {
          var _resolve3;
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          (_resolve3 = _resolve) === null || _resolve3 === void 0 || _resolve3(args);
        }
      })
    }));
  };
  var showFun = function showFun() {
    var _setVisible3;
    (_setVisible3 = _setVisible) === null || _setVisible3 === void 0 || _setVisible3(true);
    cb === null || cb === void 0 || cb();
  };
  var timerFrame;
  var toRender = function toRender() {
    cancelAnimationFrame(timerFrame);
    timerFrame = requestAnimationFrame(function () {
      isUnmount = false;
      unmount = renderToBody( /*#__PURE__*/_jsx(Wrapper, {}), showFun);
    });
  };
  modalPromise.show = function () {
    if (isUnmount) {
      toRender();
    } else {
      showFun === null || showFun === void 0 || showFun();
    }
  };
  var timer;
  modalPromise.hide = function () {
    var _hideFun3;
    var toUnmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var unmountTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
    (_hideFun3 = _hideFun) === null || _hideFun3 === void 0 || _hideFun3();
    if (toUnmount) {
      isUnmount = true;
      if (unmountTime) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var _unmount3;
          (_unmount3 = unmount) === null || _unmount3 === void 0 || _unmount3();
        }, unmountTime);
      } else {
        var _unmount4;
        (_unmount4 = unmount) === null || _unmount4 === void 0 || _unmount4();
      }
    }
  };
  toRender();
  return modalPromise;
};
export function Dialog(props) {
  var content = props.content,
    confirmText = props.confirmText,
    cancelText = props.cancelText,
    onConfirm = props.onConfirm,
    onCancel = props.onCancel,
    modalVisible = props.modalVisible;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.Dialogrule,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.ruleContent,
      children: content
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.btns,
      children: [cancelText ? /*#__PURE__*/_jsx("div", {
        className: styles.cancel,
        onClick: function onClick() {
          modalVisible === null || modalVisible === void 0 || modalVisible(false);
          onCancel === null || onCancel === void 0 || onCancel();
        },
        children: cancelText
      }) : null, confirmText ? /*#__PURE__*/_jsx("div", {
        className: styles.confirm,
        onClick: function onClick() {
          modalVisible === null || modalVisible === void 0 || modalVisible(false);
          onConfirm === null || onConfirm === void 0 || onConfirm();
        },
        children: confirmText
      }) : null]
    })]
  });
}
Dialog.show = function (props, cb) {
  var closeOnMaskClick = props.closeOnMaskClick,
    otherProps = _objectWithoutProperties(props, _excluded6);
  return showModalCenter(_objectSpread(_objectSpread({
    showClose: false,
    closeOnMaskClick: closeOnMaskClick
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Dialog, _objectSpread({}, otherProps)),
    hideBg: true
  }), cb);
};
export function showModalTop(props, cb) {
  props.position = 'top';
  props.hideBg = true;
  return showModal(props, cb);
}

// export * from '@jdh-laputa/mpass-common-comp/es/codes/comp/Popup';